import { getUtmParametersFromCookies } from '@/utils/utm/getUtmParametersFromCookies'
import { getUtmParametersFromSearchString } from '@/utils/utm/getUtmParametersFromSearchString'
import { type TUtmParameters } from '@/utils/utm/types'

export const getUtmParameters = (): TUtmParameters => {
  const utmFromSearchString = getUtmParametersFromSearchString(window.location.search)

  const hasUtmInSearchString = [
    utmFromSearchString.utmCampaign,
    utmFromSearchString.utmContent,
    utmFromSearchString.utmMedium,
    utmFromSearchString.utmSource,
    utmFromSearchString.utmTerm,
  ].some(Boolean)

  if (hasUtmInSearchString) {
    return utmFromSearchString
  }

  const utmFromCookies = getUtmParametersFromCookies()

  return utmFromCookies
}
